import React, { useState } from "react";
import { Document, Page, pdfjs } from 'react-pdf';
import 'react-pdf/dist/Page/AnnotationLayer.css';
import "react-pdf/dist/esm/Page/TextLayer.css";
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;
export default function AllPages(props) {
  const [numPages, setNumPages] = useState(null);

  function onDocumentLoadSuccess({ numPages }) {
    setNumPages(numPages);
  }

  const { pdf } = props;

  //import samplePDF from pdf;

  return (
      // <Document
    //   file={samplePDF}
    //   options={{ workerSrc: "/pdf.worker.js" }}
    //   onLoadSuccess={onDocumentLoadSuccess}
    // >
    <Document
      file={pdf}
      onLoadSuccess={onDocumentLoadSuccess}
    >
      {Array.from(new Array(numPages), (el, index) => (
        <Page scale={1.5} key={`page_${index + 1}`} pageNumber={index + 1} />
      ))}
    </Document>
  );
}